import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import Nav from 'react-bootstrap/Nav';
import Stack from 'react-bootstrap/Stack';

import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';

export default function Header() {
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster?.isDashboardDrawerOpened;

  const adminUser = JSON.parse(localStorage.getItem('adminUser'));
  const username = adminUser?.username || 'Admin';

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [syncLoading, setSyncLoading] = useState(false);

	const handleSync = async () => {
	  if (syncLoading) return;
	  handlerDrawerOpen(false);

	  setSyncLoading(true);

	  try {
		const token = localStorage.getItem('accessToken');

		const res = await fetch(
		  `${import.meta.env.VITE_API_URL}api/admin/sync`,
		  {
			method: 'POST',
			headers: {
			  Authorization: `Bearer ${token}`,
			  'Content-Type': 'application/json'
			}
		  }
		);

		const data = await res.json();

		if (data.Result === 1) {
		  alert(data.Message || 'Sync completed successfully');
		} else {
		  alert(data.Message || 'Sync failed');
		}
	  } catch (error) {
		console.error('Sync error:', error);
		alert('Server error while syncing');
	  } finally {
		setSyncLoading(false);
	  }
	};

  useEffect(() => {
    window.addEventListener('SYNC_DATA', handleSync);
    return () => window.removeEventListener('SYNC_DATA', handleSync);
  }, [syncLoading]);

  const handleLogout = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('accessToken');

      await fetch(
        `${import.meta.env.VITE_API_URL}api/admin/auth/logout`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('adminUser');
      setLoading(false);
      navigate('/login');
    }
  };

  return (
    <>
      <header className="pc-header">
        <div className="header-wrapper">
          <div className="me-auto pc-mob-drp">
            <Nav className="list-unstyled">
              <Nav.Item className="pc-h-item pc-sidebar-collapse">
                <Nav.Link
                  as={Link}
                  to="#"
                  className="pc-head-link ms-0"
                  id="sidebar-hide"
                  onClick={() => handlerDrawerOpen(!drawerOpen)}
                >
                  <i className="ph ph-list" />
                </Nav.Link>
              </Nav.Item>

              <Nav.Item className="pc-h-item pc-sidebar-popup">
                <Nav.Link
                  as={Link}
                  to="#"
                  className="pc-head-link ms-0"
                  id="mobile-collapse"
                  onClick={() => handlerDrawerOpen(!drawerOpen)}
                >
                  <i className="ph ph-list" />
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
		{syncLoading && (
		  <div
			className="me-3 d-flex align-items-center"
			style={{ zIndex: 99999 }}
		  >
			<span className="spinner-border spinner-border-sm text-primary" role="status" />
			<span className="ms-2">Syncing...</span>
		  </div>
		)}
          <div className="ms-auto">
            <Nav className="list-unstyled">
              <Dropdown className="pc-h-item" align="end">
                <Dropdown.Toggle
                  className="pc-head-link arrow-none me-0"
                  variant="link"
                  id="user-profile-dropdown"
                >
                  <i className="ph ph-user-circle" />
                </Dropdown.Toggle>

                <Dropdown.Menu className="dropdown-user-profile pc-h-dropdown p-0 overflow-hidden">
                  <Dropdown.Header className="bg-primary">
                    <Stack direction="horizontal" gap={3} className="my-2">
                      <Stack gap={1}>
                        <h6 className="text-white mb-0 text-uppercase">
                          {username}
                        </h6>
                      </Stack>
                    </Stack>
                  </Dropdown.Header>

                  <div className="dropdown-body">
                    <div
                      className="profile-notification-scroll position-relative"
                      style={{ maxHeight: 'calc(100vh - 225px)' }}
                    >
                      <div className="d-grid my-2">
                        <Button onClick={handleLogout} disabled={loading}>
                          <i className="ph ph-sign-out align-middle me-2" />
                          {loading ? 'Logging out...' : 'Logout'}
                        </Button>
                      </div>
                    </div>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </Nav>
          </div>
        </div>
      </header>
      {syncLoading && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 99998,
            background: 'transparent',
            pointerEvents: 'all'
          }}
        />
      )}
    </>
  );
}
